var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPencilDark(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3169 1.87785C15.2277 2.78871 15.2277 4.26551 14.3169 5.17638L4.68152 14.8117C4.56096 14.9323 4.39744 15 4.22695 15H0.642857C0.287817 15 0 14.7122 0 14.3571V10.7731C0 10.6026 0.0677294 10.439 0.188288 10.3185L9.82362 0.683148C10.7345 -0.227716 12.2113 -0.227716 13.1222 0.683148L14.3169 1.87785ZM13.4077 4.26724C13.8165 3.85848 13.8165 3.19574 13.4077 2.78698L12.213 1.59229C11.8043 1.18352 11.1415 1.18352 10.7328 1.59229L8.97488 3.35017L11.6498 6.02512L13.4077 4.26724ZM10.7407 6.93426L8.06574 4.25931L1.28571 11.0393V13.7143H3.96067L10.7407 6.93426Z",
    fill: "#242833"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilDark);
export default __webpack_public_path__ + "static/media/pencil-dark.5d97930c833e17929ce15e64824d9eaa.svg";
export { ForwardRef as ReactComponent };